/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React, { useState } from 'react';

import { SideOption, SideOptionIcon } from './styled';

import { withFocusable } from '@noriginmedia/react-spatial-navigation';

export default withFocusable({})(function SideButton({
  item,
  onPress,
  active,
  first,
  last,
  focused,
}: {
  item: { icon: Record<string, unknown> };
  onPress?: () => void;
  active?: boolean;
  first?: boolean;
  last?: boolean;
  focused?: boolean;
}) {
  return (
    <>
      <SideOption onPress={onPress} active={focused || active} first={first} last={last}>
        <SideOptionIcon {...item.icon} active={focused} />
      </SideOption>
    </>
  );
});
